import {Spell} from '../../generated/types';
import {Link} from '../../lib/routes';
import {humanJoin} from '../utils';

export const toSpellLinks = (spell: Spell) => {
	type SpellKeys = 'classes' | 'subClasses' | 'species' | 'feats' | 'features';
	const keys: Record<SpellKeys, string> = {
		classes: 'Классы',
		subClasses: 'Подклассы',
		species: 'Виды',
		feats: 'Черты',
		features: 'Особенности',
	};

	return (Object.keys(keys) as Array<SpellKeys>)
		.map((key) => {
			return (
				spell[key] &&
				spell[key]!.length > 0 && (
					<p key={key}>
						<b>{keys[key]}:</b>{' '}
						{humanJoin(
							spell[key]?.map((c: any) => {
								let route = '';
								let params = {};
								switch (key) {
									case 'classes':
										route = 'class';
										params = {id: c.id};
										break;
									case 'subClasses':
										route = 'subClass';
										params = {id: c.classId, subClassId: c.id};
										break;
									case 'species':
										route = 'space';
										params = {id: c.id};
										break;
									case 'feats':
										route = 'feat';
										params = {id: c.id};
										break;
									case 'features':
										if (c.specieId) {
											route = 'specieFeature';
											params = {id: c.specieId, featureId: c.id};
										} else if (c.subClassId) {
											route = 'subClassFeature';
											params = {
												id: c.subClass.classId,
												subClassId: c.subClassId,
												featureId: c.id,
											};
										} else if (c.type) {
											if (c.type === 'Invocation') {
												route = 'classInvocationFeature';
												params = {id: 'warlock', featureId: c.id};
											}
										} else {
											route = 'classFeature';
											params = {id: c.classId, featureId: c.id};
										}
								}

								return (
									<Link route={route as any} params={params} key={c.id}>
										{c.title}
									</Link>
								);
							}),
						)}
						.
					</p>
				)
			);
		})
		.filter(Boolean);
};
